<template>
  <div>
    <v-container>
      <v-form ref="form">
        <v-row>
          <h2>{{ this.pageTitle }}</h2>
        </v-row>
        <!-- custom-form overflow-y-auto -->
        <v-container id="scroll-target" class="px-5">
          <v-card>
            <div class="ma-4">
              <v-subheader class="blue--text">{{ $t('reportsparam.parameters') }} </v-subheader>

              <v-row>
                  <v-col cols="6" sm="6" class="pb-n5 ml-3">
                  <v-autocomplete dense :label="this.$t('arrearsexercise.arrearsexercise')" ref="bpexerciseid" outlined
                    v-model="bpexerciseid" :rules="[rules.required]" :items="bpexercisesList" hide-selected
                    @change="changeBpexerciseHandler(bpexerciseid)"></v-autocomplete>
                </v-col>

                <v-col cols="4" sm="4" class="pb-n5 ml-3">
                  <v-text-field outlined :label="this.$t('arrearsexercise.bpexercisecode')" type="text"
                    ref="bpexercisecode" v-model="bpexercisecode" dense readonly append-icon=""
                    background-color="#ffeab2"></v-text-field>
                </v-col>
              </v-row>

            </div>
          </v-card>

        </v-container>
        <v-spacer></v-spacer>
        <v-btn color="warning" style="width: 100px" @click="onProcess">
          {{ $t('button.go') }}
        </v-btn>
      </v-form>
    </v-container>
  </div>
</template>

<script>

export default {
  data() {
    return {
      rules: {
        required: value => !!value || 'Required.'
      },

      pageTitle: this.$t('arrearsexercise.arrearsenquiry'),
      bpexercises: [],
      bpexercisesList: [],
      bpexerciseid: '',
      bpexercisecode: '',

    };
  },


  methods: {

    onProcess() {
      if (this.$refs.form.validate()) {
        const id = this.bpexerciseid;
        this.$router.push({
          name: "arrearsenquirydetail",
          query: { id },
        });
      }

    },

    loadBpexerciseListHandler() {
      const vm = this;

      this.$store.dispatch('get', { url: '/arrearsexercise/all' })
        .then(res => {
          vm.bpexercises = res.data.rec;

          for (let i = 0; i < res.data.rec.length; i++) {
            vm.bpexercisesList.push(
              {
                text: res.data.rec[i].bpexercisedesc,
                value: res.data.rec[i].id
              }
            )
          }
        })
        .catch(err => {
          vm.isErr = true;
          vm.errMsg = err;
          vm.$emit('error', { isErr: vm.isErr, errMsg: vm.errMsg });
        });
    },
    changeBpexerciseHandler(id) {
      let item = this.bpexercises.find(item => item.id === id);
      this.bpexercisecode = item.bpexercisecode;
    },

  },

  mounted() {
    this.loadBpexerciseListHandler();
  },

};
</script>